'use strict';

(function () {
    var testimonialPopover = function testimonialPopover() {
        $('.full-testimonial-link').popover({
            html: true,
            trigger: 'click',
            placement: 'right',
            container: 'body',
            content: function content() {
                var name = $(this).data('name');
                return $('#' + name).html();
            }
        });
    };

    // Exports
    window.testimonialPopover = testimonialPopover;
})();